module.exports = __webpack_public_path__ + "img/companyIntro9.27a2810b.png";